import { REGEX_CITY_NAME_FORBIDDEN_SYMBOLS } from 'clickNgo/configs/regex'

export const checkCityName = (value: string) => {
  if (REGEX_CITY_NAME_FORBIDDEN_SYMBOLS.test(value) || value.length < 2) {
    return 'The field City has an incorrect value'
  }
  return ''
}
